import { variables } from '../variables';
import OnestBold from '../../fonts/GoldSilver/Onest-Bold.woff2';
import OnestMedium from '../../fonts/GoldSilver/Onest-Medium.woff2';
import OnestRegular from '../../fonts/GoldSilver/Onest-Regular.woff2';
import InstrumentSansBold from '../../fonts/GoldSilver/InstrumentSans-Bold.woff2';
import InstrumentSansRegular from '../../fonts/GoldSilver/InstrumentSans-Regular.woff2';
import InstrumentSansMedium from '../../fonts/GoldSilver/InstrumentSans-Medium.woff2';

export const goldSilverColors = {
  colorPrimary: '#052D6B', // GoldSilver Blue
  colorPrimaryLight: '#DCF2FD', // GoldSilver Tint
  colorPrimaryDark: '#052D68', // GoldSilver Shade
  colorBrandLight: '#FCB817', // GoldSilver Yellow
  colorWhite: '#ffffff',
  colorBlack: '#3D3D3D',
  colorRed: '#FF5028',
  colorGrey: '#f4f4f4',

  // Backgrounds
  colorBackgroundPrimary: '#ffffff',
  colorBackgroundSecondary: '#fafafa',
  colorWarningnBackground: '#FFECB5',

  // Typography Colors
  // Text
  colorTextPrimary: '#3D3D3D',
  colorTextSecondary: '#505575',
  colorTextContrast: '#ffffff',
  colorTextHeader: '#ffffff',
  colorTextLink: '#ffffff',

  colorSuccess: '#2E8B57',
  colorError: '#B3261E',
  colorWarning: '#E2930A',
  colorIncomplete: '#212528',

  // Links
  colorLinkPrimary: '#052D6B',
  colorLinkRegistration: '#003246', // semiDark'

  // Button Colors
  colorButtonPrimary: '#052D6B',
  colorButtonPrimaryText: '#ffffff',
  colorButtonPrimaryHover: 'rgba(26, 73, 147, 0.9)',
  colorButtonPrimaryFocused: 'rgba(26, 73, 147, 0.9)',
  colorButtonPrimaryHoverText: '#ffffff',
  colorButtonOutlined: '#ffffff',
  colorButtonOutlinedBorder: '#052D6B',
  colorButtonOutlinedText: '#052D6B',
  colorButtonDisabled: 'rgba(26, 73, 147, 0.5)',

  colorButtonDefault: '#ffffff',
  colorButtonDefaultText: '#052D68',
  colorButtonDefaultBorder: '#052D68',
  colorButtonDefaultHover: '#8b8b8b',
  colorButtonAddNewBank: '#ffffff',

  // Input
  colorInputBorder: '#c4c4c4',
  colorInputBackground: '#ffffff',
  colorInputBorderFocused: '#505575',
  colorInputBorderActive: '#c8c8c8',
  colorInputBackgroundDisabled: '#EBF2F2',
  colorInputText: '#505575',
  colorInputPlaceholder: '#4E7A8C',
  colorInputSelectItemFocused: '#f4f4f4',

  // Label
  colorLabel: '#505575',

  // Modal
  colorModalBackground: 'rgba(0, 0, 0, 0.3)',

  // Tabs
  colorTabBackground: '#ffffff',
  colorTabText: '#052D6B',
  colorTabSelectedBackground: '#052D6B',
  colorTabSelectedText: '#ffffff',

  // Pills
  colorPillsBackground: '#ffffff',
  colorPillsText: '#3D3D3D',
  colorPillsBackgroundActive: '#052D6B',
  colorPillsTextActive: '#ffffff',

  // Filters
  colorFilterItemBackground: '#052D68',
  colorFilterItemText: '#ffffff',
  colorFilterIcon: '#ffffff',

  // Icons
  colorIconPrimary: '#052D68',
  colorIconSecondary: '#D89948',
  colorLoaderIcon: '#DCF2FD',

  // Radio Button
  colorRadioButton: '#003246',
  colorRadioButtonWrapperBorderSelected: '#D89948',

  // Tooltip
  colorTooltipBackground: '#052D68',
  colorTooltipText: '#ffffff',

  // Password Strength
  colorPasswordStrengthDefault: '#EBF2F2',
  colorPasswordStrengthWeak: '#FF5028',
  colorPasswordStrengthAverage: '#FDB942',
  colorPasswordStrengthGood: '#06BEE7',
  colorPasswordStrengthStrong: '#00876A',

  // Progress Bar Colors, Linear Gradient
  colorLinearGradientStart: '#052D6B',
  colorLinearGradientEnd: '#052D68',
  colorProgressBarDefault: '#F4F4F4',
  colorProgressBarFilled: '#D89948',

  // Header Colors
  colorMainHeaderBackground: '#052D68',
  colorSecondaryHeaderBackground: '#ffffff',
  colorHeaderLogoLight: '#ffffff',
  colorHeaderLogoDark: '#003246',

  // Navigation Colors
  colorNavigationItemHover: '#FCB817',

  // Navigation Dropdown Color
  colorNavigationDropdownBackground: '#052D68',
  colorNavigationDropdownItemHoverBackground: 'rgba(7, 44, 100, 0.5)',

  // Account Colors
  colorAccountBackground: '#020c17',
  colorAccountBorder: 'rgba(255,255,255, 0.2)',

  // Footer Colors
  colorFooterBackground: '#052D68',
  colorFooterText: '#dddddd',

  // Horizontal Break and Borders, Separators
  colorBorderPrimary: '#c9d6db',
  colorBorderSecondary: '#D89948',

  // Table Colors
  colorTableHeaderBackground: '#f4f4f4',
  colorTableEvenRowBackground: '#fafafa',
  colorTableEvenRowHoverBackground: '#f4f4f4',
  colorTableSelectedBackground: 'rgba(226, 147, 10, 0.14)',
  colorHeadingRowItem: '#F0F5F6',

  // Shippment Status Colors
  colorShippmentSuccess: '#09846b',
  colorShippmentPending: '#E2930A',
  colorShippmentShipped: '#024f86',
  colorShippmentFailed: '#ff5028',

  // Address Status Colors
  colorVerifiedSuccess: '#09846b',
  colorNotVerified: '#8E8E8E',

  // Card Colors
  colorCardBackground: '#ffffff',
  colorCardSelected: 'rgba(226, 147, 10, 0.14)',

  // Scrollbar Colors
  colorScrollbarBackground: '#c2c5c6',

  // MakeOver Banner
  colorMakeOverBannerBackground: '#f5f5f5',
  colorMakeOverBanner: '#003246',

  // Pending Banner
  colorPendingBannerBackground: '#f1f5f6',

  // Onboarding
  colorOnboardingBoxBorder: '#f3f3f3',
  colorOnboardingBoxBackground: 'rgba(196, 196, 196, 0.2)',
  colorOnboardingTextPrimary: '#ffffff',

  // Empty Box
  colorEmptyBoxTextPrimary: '#C2C5C6',

  // Graphic
  colorGraphicGridLines: '#ebeff2',

  // Info Banner
  colorInfoBannerBackground: '#003246',
  colorInfoBannerBackground2: '#003246',
  colorInfoBannerText: '#ffffff',

  // Auth card
  colorAuthCardSubtitle: 'rgb(0, 50, 70)',

  // Registration
  colorRegistration: '#052D6B',

  // Pie chart
  colorPieOne: '#003246',
  colorPieTwo: '#D89948',
  colorPieThree: '#4E7A8C',
  colorPieFour: '#808285',

  // Sidebar Gradients
  colorSidebarBegin: '#052D68',
  colorSidebarEnd: '#052D68',

  // Graph line
  colorGraphLine: '#FCB817',

  // Tags
  colorTag: '#FCB817',

  // Filters
  colorFilter: '#FCB817',

  // Add Button
  colorAddButton: '#FCB817',

  // Focus color
  colorFocus: '#FCB817',

  // Flag color
  colorFlag: '#2E8B57',

  // Color note background
  colorNoteBackground: 'rgba(7, 44, 100, 0.1)',

  // Terms Modal
  colorInfoTitle: '#3D3D3D',
  colorInfoText: '#505575',
  colorInfoLine: 'rgba(80, 85, 117, 0.3)',
  colorTermsBoxBg: 'rgba(80, 85, 117, 0.03)',
  colorInfoBoxBorder: '#2E8B57',
  colorInfoBoxText: '#2E8B57',
  colorInfoBoxBg: 'rgba(46, 139, 87, 0.03)',

  // Quick Reg Colors
  colorRegCardBackground: '#1E427A',
  colorRegCardSubtitleText: '#FEB913',
  colorCardTypeTwoBorder: 'rgba(255, 255, 255, 0.6)',
  colorExpandLink: '#44B0FF',
  colorRegistrationInputBackground: '#F9F9F9',
  colorRegistrationInputBorder: '#E3E6E9',
};

export const goldSilverFonts = `
  @font-face {
    font-family: ${variables.family.goldSilver};
    src: url(${InstrumentSansBold}) format('woff2');
    font-weight: bold;
    font-style: normal;
    font-display: fallback;
  }

  @font-face {
    font-family: ${variables.family.goldSilver};
    src: url(${InstrumentSansMedium}) format('woff2');
    font-weight: 600;
    font-style: normal;
    font-display: fallback;
  }

  @font-face {
    font-family: ${variables.family.goldSilver};
    src: url(${InstrumentSansMedium}) format('woff2');
    font-weight: 500;
    font-style: normal;
    font-display: fallback;
  }

  @font-face {
    font-family: ${variables.family.goldSilver};
    src: url(${InstrumentSansRegular}) format('woff2');
    font-weight: normal;
    font-style: normal;
    font-display: fallback;
  }

  @font-face {
    font-family: ${variables.family.goldSilverHeaders};
    src: url(${OnestBold}) format('woff2');
    font-weight: bold;
    font-style: normal;
    font-display: fallback;
  }

  @font-face {
    font-family: ${variables.family.goldSilverHeaders};
    src: url(${OnestMedium}) format('woff2');
    font-weight: 600;
    font-style: normal;
    font-display: fallback;
  }

  @font-face {
    font-family:  ${variables.family.goldSilverHeaders};
    src: url(${OnestRegular}) format('woff2');
    font-weight: normal;
    font-style: normal;
    font-display: fallback;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  h1 *,
  h2 *,
  h3 *,
  h4 *,
  h5 *,
  h6 * {
  font-family: ${variables.family.goldSilverHeaders};
  font-weight: bold;
}

  *,
  *::after,
  *::before {
    font-family: ${variables.family.goldSilver};
  }
`;
